import React from "react";

import { Input as BaseInput } from "../components/base-ui/input";

type InputProps = React.ComponentProps<"input">;
export interface NewInputProps extends Omit<InputProps, "value"> {
  value?: InputProps["value"] | null;
}

export function Input(props: NewInputProps) {
  const { value, ...rest } = props;

  // Only pass value prop if explicitly provided (for controlled inputs)
  // If value is undefined, omit it entirely to allow uncontrolled inputs
  if (value === undefined) {
    return <BaseInput data-slot="input" {...rest} />;
  }

  // Prevent passing NaN or null to the DOM. Keep the input controlled by using "" for empty states.
  const safeValue =
    value === null || (typeof value === "number" && Number.isNaN(value))
      ? ""
      : value;

  return <BaseInput data-slot="input" {...rest} value={safeValue} />;
}
